// Debug logging that is silent in production builds.
// console.error is deliberately left untouched across the app so real failures
// still surface in the browser console for users reporting problems.
const enabled = process.env.NODE_ENV !== 'production';
const noop = () => {};

const logger = {
  log: enabled ? console.log.bind(console) : noop,
  warn: enabled ? console.warn.bind(console) : noop,
  error: console.error.bind(console),
};

export default logger;
